export default __webpack_public_path__ + "static/media/pins.e7e0f61f.svg";